module.exports = __webpack_public_path__ + "img/plane-newsletter.e3c42e65.svg";